// CACHE_DURATION is 10 minutes by default and used internally by validateCache to check timeout
const CACHE_DURATION = 6e5; // 10 minutes
// CACHE_KEY is used in the reducer with Date.now() to save date of last update
const CACHE_KEY = 'CACHED_AT' as const;

export { CACHE_DURATION, CACHE_KEY };
